import * as React from "react"
import { type VariantProps } from "class-variance-authority"
import cn from "@/v2-ui/utils/utils.cn"
import { badgeCoreVariants } from "@/v2-ui/badge/base/badge.base.constants"

type BadgeProps = React.ComponentProps<"div"> &
  VariantProps<typeof badgeCoreVariants>

const Badge = ({ className, variant, size, pill, ...props }: BadgeProps) => (
  <div
    className={cn(badgeCoreVariants({ variant, size, pill }), className)}
    {...props}
  />
)
Badge.displayName = "Badge"

export { Badge }
